import React from 'react';
import { NavCard } from '../simba-cards';
import { NavCardLink } from '../styled-link/StyledLink';
import { useDocumentUrlWithNode } from '../../hooks/Documents/useDocumentUrl';
import { RelatedArticleType } from '../../../../types/articleType';
import { ShortCutCol } from './Styles';

export const SecondaryEntryCard = ({ entry }: { entry: RelatedArticleType }) => {
  const itemUrl = useDocumentUrlWithNode(entry) || '';
  return (
    <ShortCutCol s="12" m="6" l="4" xl="4" key={`${entry.name}${entry.slug}`}>
      <NavCardLink to={itemUrl}>
        <NavCard title={entry.name} isInternalLink height="100%" />
      </NavCardLink>
    </ShortCutCol>
  );
};
